
<template>
  <span ref="text" class="sub-text w-100" :title="txt">
    {{subText(txt, size)}}
  </span>
</template>

<script setup>

import {subText} from "@/mixins/Helpers";
import {onMounted, ref, watch} from "vue";

const props = defineProps({
  txt: String,
  size: { type: Number, default: 20 },
})


const text = ref()

watch(() => [text, props.txt], () => {
}, { deep: true })


</script>

<style scoped>

</style>